import React from 'react';
import { useLanguage } from '../../contexts/LanguageContext.js';
import { 
  BuildingStorefrontIcon,
  MapPinIcon,
  IdentificationIcon,
  CurrencyDollarIcon
} from '@heroicons/react/24/outline';

const AutoShopStats = ({ clients }) => {
  const { t } = useLanguage();

  const stats = [
    {
      name: t('totalAutoShops'),
      value: clients.length,
      icon: BuildingStorefrontIcon,
      color: 'bg-blue-500'
    },
    {
      name: t('withAddress'),
      value: clients.filter(client => client.address).length,
      icon: MapPinIcon,
      color: 'bg-green-500'
    },
    {
      name: t('businessEntities'),
      value: clients.filter(client => client.customerSubtype === 'BUSINESS_ENTITY').length,
      icon: IdentificationIcon,
      color: 'bg-purple-500'
    },
    {
      name: t('vatPayers'),
      value: clients.filter(client => client.vatPayer).length,
      icon: CurrencyDollarIcon,
      color: 'bg-orange-500'
    }
  ];

  return (
    <div className="mb-8 overflow-x-auto pb-2">
      <div className="flex gap-4 min-w-max md:grid md:grid-cols-2 lg:grid-cols-4 md:min-w-0">
        {stats.map((stat) => (
          <div key={stat.name} className="bg-white overflow-hidden shadow rounded-lg w-48 flex-shrink-0 md:w-auto">
            <div className="p-4 md:p-5">
              <div className="flex items-center">
                <div className="flex-shrink-0">
                  <div className={`${stat.color} rounded-md p-2 md:p-3`}>
                    <stat.icon className="h-5 w-5 md:h-6 md:w-6 text-white" aria-hidden="true" />
                  </div>
                </div>
                <div className="ml-4 md:ml-5 w-0 flex-1">
                  <dl>
                    <dt className="text-xs md:text-sm font-medium text-gray-500 truncate">
                      {stat.name}
                    </dt>
                    <dd className="text-base md:text-lg font-medium text-gray-900">
                      {stat.value}
                    </dd>
                  </dl>
                </div>
              </div>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default AutoShopStats;
